import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { connect } from 'react-redux';
import {
  Card,
  CardTitle,
  CardSubtitle,
  CardBody,
  Button
} from 'shards-react';
import moment from 'moment';

import NoteTagBadge from './noteoverlay/NoteTagBadge';
import { displayNote } from '../../store';


class NoteCard extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      preview: null,
      loadingPreview: false
    };
  }

  componentDidMount() {
    const note = this.props.note;
    if (note.isLink()) {
      this.setState({loadingPreview: true});
      note.fetchPreview()
        .then(preview => this.setState({preview}))
        .catch(err => console.log(`failed to fetch URL preview for ${note.title}: ${err}`))
        .finally(() => {this.setState({loadingPreview: false})})
    }
  }

  onClick(e) {
    e.preventDefault();
    this.props.dispatch(displayNote(this.props.note.id));
  }

  deleteNote() {
    this.props.note.delete();
  }

  /**
   * Converts a html string into a tree of React elements.
   */
  renderHtml(html) {
    return ReactHtmlParser(html);
  }

  renderImageElement(url) {
    return <img
    className="background-image"
      src={`${window.config.API_URL}/v0/imageproxy?url=${url}`}
      alt="" />;
  }

  renderTitle() {
    const preview = this.state.preview;
    if (this.props.note.isLink()) {
      const url = preview ? preview.url : this.props.note.getUrl();
      const title = preview ? preview.title : url;
      return <CardTitle>
        <a href={url} target="_blank" rel="noopener noreferrer" onClick={e => e.stopPropagation()}>
          {title} <span role="img" aria-label="external link">🌎</span> <i className="material-icons">open_in_new</i>
        </a>
        {this.renderSubtitle()}
        <hr />
      </CardTitle>;
    } else {
      return this.props.note.title && <CardTitle>
        {this.props.note.title}
        {this.renderSubtitle()}
        <hr />
      </CardTitle>;
    }
  }

  renderSubtitle() {
    let created = this.props.note.createdAt;
    let updated = this.props.note.updatedAt;
    if (!created && !updated) {
      return;
    }
    return <CardSubtitle>
      {created && `Created ${formatTimestamp(created)}`}
      {created && updated && <br />}
      {updated && `Updated ${formatTimestamp(updated)}`}
    </CardSubtitle>
  }

  renderDescription() {
    if (this.state.loadingPreview) {
      return '🌎 Loading...';
    }
    const preview = this.state.preview;
    return preview ? preview.description : this.renderHtml(this.props.note.html);
  }

  render() {
    const preview = this.state.preview;
    const image = preview && preview.image_url ? this.renderImageElement(preview.image_url) : '';
    const tags = this.props.note.tags.map((tag, index) => <NoteTagBadge key={index} readOnly>{tag}</NoteTagBadge>);

    return <Card className="note-card" onClick={this.onClick.bind(this)}>
      <CardBody className="note-card-body">
        {this.renderTitle()}
        <hr />
        <div className="note-card-content">{this.renderDescription()}</div>
        <div class="note-card-footer">
          <div style={{flexGrow: 1}}>{tags}</div>
          <Button
            size="sm"
            theme="danger"
            style={{ alignSelf: 'flex-end' }}
            onClick={this.deleteNote.bind(this)}
          >X</Button>
        </div>
        {image}
      </CardBody>
    </Card>
  }
}

export function formatTimestamp(timestamp) {
  let m = moment.unix(timestamp)
  let now = moment()
  let isOld = m.isBefore(now.subtract(1, 'month'))
  if (isOld) {
    return m.format('YYYY-MM-DD');
  } else {
    return m.fromNow()
  }
}

export default connect()(NoteCard);